export function downloadFile(content: string, contentType: string, fileName: string): void {
    const blob = new Blob([content], { type: contentType, endings: 'native' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    document.body.appendChild(anchor);
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
    setTimeout(() => {
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    }, 0);
}
